<template>
  <div class="flex flex-wrap w-full p-0 m-0">
    <div class="lg:w-12/12 lg:pr-2">
      <p class="pb-1">Les bonnes réponses</p>
      <div v-if="question.answer" v-html="question.answer"></div>
      <div class="relative quiz-form" :id="'lineContainer-' + question.id">
        <div
          ref="elmPoint"
          id="elm-point"
          class="absolute hidden w-0 h-0"
        ></div>
        <div class="flex flex-wrap justify-between w-full">
          <div class="flex-1 w-[46%]">
            <div class="leftList" ref="leftItems">
              <div
                v-for="(element, idx) in leftList"
                class="relative flex items-center bg-white question-drag-item border border-solid border-dark rounded-2xl p-1.5 mb-1 text-sm lg:text-lg text-dark"
              >
                <span v-html="element.title"></span>
              </div>
            </div>
          </div>
          <div class="flex-none w-6">
            <div class="middleList" ref="rightItems">
              <div
                v-for="(element, idx) in leftList"
                class="relative flex items-center text-dark border border-solid border-light rounded-2xl p-1.5 mb-1 text-sm lg:text-lg"
              >
                <div
                  class="flex items-center justify-center w-2 h-2 mx-0.5 rounded answer-icon text-black bg-green"
                  v-if="
                    leftList.map(({ id }) => id).indexOf(element.id) ==
                    rightList
                      .filter(({ column }) => column == 1)
                      .map(({ id }) => id)
                      .indexOf(parseInt(answer.choices[element.id]))
                  "
                >
                  <CheckIcon class="w-1 h-1" />
                </div>
                <div
                  class="flex items-center justify-center w-2 h-2 mx-0.5 rounded answer-icon text-black bg-green"
                  v-else
                >
                  <CheckIcon class="w-1 h-1" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1 w-[46%]">
            <div class="rightList" ref="rightItems">
              <div
                v-for="(element, idx) in rightList"
                class="relative flex items-center bg-dark text-white answer-drag-item border border-solid border-light rounded-2xl p-1.5 mb-1 text-sm lg:text-lg"
              >
                <span v-html="element.title"></span>
              </div>
            </div>
          </div>
        </div>
        <!-- .grid -->
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, onUpdated, onUnmounted, ref } from "vue";
import { useQuizStore } from "@/stores/quiz";
import CheckIcon from "./icons/CheckIcon.vue";

const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  answer: {
    // type: Object,
    required: true,
  },
});

const quizStore = useQuizStore();

const leftList = ref(props.question.answers.filter((elt) => elt.column == 0));
const rightList = ref(props.question.answers.filter((elt) => elt.column == 1));

onMounted(() => {
  window.addEventListener("resize", () => {
    setBoxesHeight();
  });
  setBoxesHeight();
});

onUpdated(() => {
  setBoxesHeight();
});

const setBoxesHeight = () => {
  console.log("setBoxesHeight");
  // reset height
  const allBoxes = document.querySelectorAll(
    "#lineContainer-" +
      props.question.id +
      " .leftList > div, #lineContainer-" +
      props.question.id +
      " .middleList > div, #lineContainer-" +
      props.question.id +
      " .rightList > div"
  );
  allBoxes.forEach((elt) => (elt.style.height = "unset"));
  // get max height

  const maxHeight = Math.max(
    ...Object.values(allBoxes).map((elt) => elt.offsetHeight)
  );
  // apply height
  allBoxes.forEach((elt) => (elt.style.height = maxHeight + "px"));
};
</script>
